module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "frontmatter",
      "id": "ser"
    }
  }, [_c('p', {
    staticClass: "rvh"
  }, [_vm._v("Advance praise for "), _c('i', [_vm._v("Saint Peter and the Goldfinch")])]), _vm._v(" "), _c('p', {
    staticClass: "rvf"
  }, [_vm._v("“Open this book to page 27 and read ‘Ice Storm.’ Feel how it settles in your chest, how your breath resounds with a long, deep, ‘Yes,’ how subtly you are changed by what you didn’t know you knew. I’ve been reading Jack Ridl’s poems with admiration and wonder for almost forty years now and this new work goes ever deeper into the intensified heart of our everyday lives.”")]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_vm._v("—Dan Gerber")]), _vm._v(" "), _c('p', {
    staticClass: "rvf"
  }, [_vm._v("“The amazing poetry of Jack Ridl is written ‘in the dust along the windowsill, / the star’s lost light falling across / the vase of flowers on the kitchen table.’ They are windows opening to mortality; they strike with the grace of starlight, and the warmth of flowers beside a meal. Ridl never fails to illuminate.”")]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_vm._v("—Terrance Hayes, poet and professor")]), _vm._v(" "), _c('p', {
    staticClass: "rvf"
  }, [_vm._v("“These poems typically begin with a series of quiet, levelheaded observationsand end in a wild imaginative leap. Jack Ridl has found a pattern that delights and surprises us poem by poem.”")]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_vm._v("—Billy Collins")]), _vm._v(" "), _c('p', {
    staticClass: "rvf"
  }, [_vm._v("“For a long time now, Jack Ridl has understood The Word, The Logos, as a meeting place of the body and the mind, the past and the emerging present, time and eternity, the concrete and the abstract, the inner and the outer worlds, the human will and the unknown, and he has practiced said Word as a way to clarify his heart, rectify his spirit, and demystify the workings of the human eye in order to realize human consciousness as a blessing, rather than a blight characterized by confusion and error. In his latest book, we witness his practice deepening, and not far below the warm and neighborly tone of these poems is the sound of a man more and more alone with The Alone. By salvaging what he can of the real and immediate world around him, he preserves for us the idea of The Human as precious and worth saving.”")]), _vm._v(" "), _c('p', {
    staticClass: "rvt"
  }, [_vm._v("—Li-Young Lee, author of "), _c('i', [_vm._v("The Undressing")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efbcca4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-ridl-0002.vue
// module id = 57
// module chunks = 0